import Vue from 'vue'
import Vuex from 'vuex'
import { getSavedTheme, applyTheme } from '@/utils/theme'
import { getSavedQuoteColorMode, applyQuoteColorMode } from '@/utils/quoteColors'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: getSavedTheme(),
    quoteColorMode: getSavedQuoteColorMode()
  },
  mutations: {
    setQuoteColorMode(state, mode) {
      state.quoteColorMode = mode === 'green-up' ? 'green-up' : 'red-up'
      applyQuoteColorMode(state.quoteColorMode)
    },
    setTheme(state, theme) {
      state.theme = theme === 'light' ? 'light' : 'dark'
      applyTheme(state.theme)
    }
  },
  actions: {
  },
  modules: {
  }
})
